import React, { useEffect, useCallback, useState} from 'react';
import Edge from "./Edge.js";
import Speakers from "components/pulled/Speakers.js";
import AllEdges from './AllEdges.js';
import PadEffectControl from './PadEffectControl.js';
import PulledEffect from "components/pulled/PulledEffect.js"
import {connect} from 'react-redux';

const TrackMidiEffects = ({
    track,
    effects,
    isCollapsed,
    ... props
}) => { 
    const onDelete = useCallback((fx) => {
        track.effectRack.deleteEffect(fx);
        track.updateMidiEffectsRedux();
    }, []);

    if (!track.effectRack || isCollapsed) { 
        return [];
    }
    return [
        <Speakers
          isMidi={true}
          key={5}
          pad={track}
          {...props}
        />,
        , ...
            track.effectRack.effects.map(
                effect => 
                    <PulledEffect
                      onDelete={onDelete}
                      key={effect.id}
                      fx={effect}
                      rack={track.effectRack}
                      showDelete={true}
                      sequencerEngine={track.sequencerEngine}
                      pad={track}
                      {...props}
                    />)
        ];
};

const mapStateToProps = (state, props) => {
    let rackId = props.track.effectRack &&
        props.track.effectRack.id;
    return {
        effects: state.pads.trackMidiEffects[props.track.id],
        isCollapsed: state.effects.effectCollapsed[rackId]
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackMidiEffects);
